<template>
  <el-dialog custom-class="list-dialog" title="库存详情" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="20">
          <el-select v-model="minyear" placeholder="" style="width:80px" size="mini" @change="search">
            <el-option
              v-for="item in getYearList()"
              :key="item+''"
              :label="item+''"
              :value="item+''">
            </el-option>
          </el-select>
          <el-select v-model="minmonth" placeholder="" style="width:65px" size="mini" @change="search">
            <el-option
              v-for="item in monthList"
              :key="item+''"
              :label="item+''"
              :value="item+''">
            </el-option>
          </el-select>
          <el-select class="Select" v-model="cangkucode" placeholder="请选择仓库" style="width:130px" size="mini" @change="search">
            <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                       :label="item.cangkuname"
                       :value="item.cangkucode">
            </el-option>
          </el-select>
          <el-input style="width:100px;" v-model="Y" placeholder="输入型号" @change="change1" size="mini"></el-input>
          <el-input style="width:100px;" v-model="X" placeholder="输入规格" @change="change2" size="mini"></el-input>
          <el-checkbox v-model="checkXL" size="mini" @change="search">查询全系列库存</el-checkbox>
          <!--<el-button type="primary" icon="el-icon-search" @click="search" size="mini">搜索</el-button>-->
        </el-col>
        <el-col :span="4">
        </el-col>
        <!--<el-col :span="6">-->
          <!--&lt;!&ndash;<el-button type="primary" icon="el-icon-download" @click="exportExcel()" size="mini">导出</el-button>&ndash;&gt;-->

          <!--<el-button type="primary" @click="print1" v-if="false">打印库存表</el-button>-->
        <!--</el-col>-->
      </el-col>
      <CstagreementMachiningEdit v-if="true" ref="machiningedit"></CstagreementMachiningEdit>
      <CstagreementMachiningEdit v-if="true" ref="machiningeditcopy"></CstagreementMachiningEdit>
      <CstagreementEdit v-if="true" ref="DataContactEditCopy" @ceshi="ceshi"></CstagreementEdit>
      <CstagreementEdit v-if="true" ref="DataContactEdit"></CstagreementEdit>
      <AllocationDetail v-if="true" ref="AllocationDetail"></AllocationDetail>
      <MakeInventoryEdit v-if="true" ref="MakeInventoryEdit"></MakeInventoryEdit>
      <MakeInventoryFrameEdit v-if="true" ref="MakeInventoryFrameEdit"></MakeInventoryFrameEdit>
      <StorageBadOut v-if="true" ref="StorageBadOut"></StorageBadOut>
      <BuyorderDetail ref="BuyorderDetail" @bindGrid="bindGrid"></BuyorderDetail>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
    </div>
    <el-col :span="24">
      <el-col :span="24">
        <el-table
          :data="tableData2"
          v-show="tip()"
          size="mini"
          border
          style="width: 100%;">
          <el-table-column label="日期" align="center" header-align="center" width="150" prop="accdate"></el-table-column>
          <el-table-column label="订单号" align="center" header-align="center" width="150" prop="ordernum">
            <template slot-scope="scope">
                  <span @click="lookorder(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordernum==undefined?scope.row.erpserial:scope.row.ordernum}}
                  </span>
            </template>
          </el-table-column>
          <el-table-column label="单据类型" align="left" header-align="center" width="100" prop="ordername">
            <template slot-scope="scope">
                  <span @click="lookorder(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordername==undefined?scope.row.erpformname:scope.row.ordername}}
                  </span>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" align="left" header-align="center" width="180" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.seedname }}
            </template>
          </el-table-column>
          <el-table-column label="型号" align="left" header-align="center" width="90" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{scope.row.M}}
            </template>
          </el-table-column>
          <el-table-column label="规格" align="left" header-align="center" width="90" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{scope.row.C}}
            </template>
          </el-table-column>
          <el-table-column label="入库" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.debitnum == 0 ? "" : scope.row.debitnum}}
            </template>
          </el-table-column>
          <el-table-column label="出库" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.creditnum == 0 ? "" : scope.row.creditnum}}
            </template>
          </el-table-column>
          <el-table-column label="结存" align="right" header-align="center" width="70">
            <template slot-scope="scope">
              {{scope.row.subtractnum == 0 ? "" : scope.row.subtractnum}}
            </template>
          </el-table-column>
        </el-table>
        <h3 style="line-height: 50px">调拨途中</h3>
        <el-table
          :data="transfernumData.filter(data =>
          (!Y||data.M.toLowerCase().includes(Y.toLowerCase()))&&
          (!X||data.C.toLowerCase().includes(X.toLowerCase()))
          )"
          size="mini"
          border
          :summary-method="getSummaries"
          show-summary
          style="width: 100%;">
          <el-table-column label="发出日期" align="center" header-align="center" prop="accdate" width="150" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="订单号" align="center" header-align="center" width="150" prop="erpserial">
            <template slot-scope="scope">
                  <span @click="lookorder(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{scope.row.erpserial}}
                  </span>
            </template>
          </el-table-column>
          <el-table-column label="发货仓" align="left" header-align="center" prop="cangkuname" width="100"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="商品名称" align="left" header-align="center" prop="seedname" width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="型号" align="left" header-align="center" width="90" prop="M"  :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'M') }}
            </template>
          </el-table-column>
          <el-table-column label="规格" align="left" header-align="center" width="90" prop="C" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'C') }}
            </template>
          </el-table-column>
          <el-table-column label="数量" align="right" header-align="center" prop="transfernum" width="70">
            <template slot-scope="scope">
              {{scope.row.transfernum == 0 ? "" : scope.row.transfernum}}
            </template>
          </el-table-column>
        </el-table>
       <h3 style="line-height: 50px">已售待出库</h3>
        <el-table
          :data="deliverData.filter(data =>
          (!Y||data.M.toLowerCase().includes(Y.toLowerCase()))&&
          (!X||data.C.toLowerCase().includes(X.toLowerCase()))
          )"
          size="mini"
          border
          :summary-method="getSummaries"
          show-summary
          style="width: 100%;">
          <el-table-column label="开单日期" align="center" header-align="center" prop="htqd" width="150" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="订单号" align="center" header-align="center" width="150" prop="erpserial">
            <template slot-scope="scope">
                  <span @click="lookorder(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{scope.row.erpserial}}
                  </span>
            </template>
          </el-table-column>
          <el-table-column label="门店" align="left" header-align="center" prop="customername" width="100"
                           :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="商品名称" align="left" header-align="center" prop="seedname" width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="型号" align="left" header-align="center" width="90"  prop="M" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'M') }}
            </template>
          </el-table-column>
          <el-table-column label="规格" align="left" header-align="center" width="90" prop="C" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ getPackagesize(scope.row.packagesize,'C') }}
            </template>
          </el-table-column>
          <el-table-column label="数量" align="right" header-align="center" prop="deliverying" width="70">
            <template slot-scope="scope">
              {{scope.row.deliverying == 0 ? "" : scope.row.deliverying}}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <UniqueCode ref="UniqueCode"></UniqueCode>
      <zhinengstock ref="zhinengstock" @afterSet="search"></zhinengstock>
    </el-col>
  </el-dialog>
</template>

<script>


  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import TwoDimensionalView from '@/components/set/goodsprice/TwoDimensionalView';
  import glassFrameView from '@/components/set/goodsprice/glassFrameView';
  import {formatTimeToStr} from '@/plugin/Date';
  import {getGoodsListWithStoreDetail, getStoreFormList, stayDelivar,stayTransfernumMap, getGoodsNeedBuy} from '@/api/set/jxcresultstore';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import CstagreementMachiningEdit from '../cstagreement/CstagreementMachiningEdit';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import AllocationDetail from '@/components/warehouse/AllocationDetail';
  import BuyorderDetail from '@/components/testorder/buyagreement/BuyorderDetail'
  import MakeInventoryEdit from '@/components/warehouse/MakeInventoryEdit'
  import MakeInventoryFrameEdit from '@/components/warehouse/MakeInventoryFrameEdit'
  import StorageBadOut from '@/components/warehouse/StorageBadOut'
  import UniqueCode from '@/components/testorder/warehouse/UniqueCode'
  import zhinengstock from '@/components/testorder/warehouse/zhinengstock'
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import {exportExcel} from '@/api/file'
  import {listData} from '@/api/set/jxcstoregoodsbarcode';

  export default {
    name: "StorageFrameView",
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        currentcomponent: "",
        defaulttabname: "storedetail",
        showtab: 1,
        checkXL:false,
        dialogFormVisible: false,
        categorycode:'',
        packagesize:'',
        xcolumn: [],
        ycolumn: [],
        RorL: '',
        minyear: yearnow,
        minmonth: monthnow,
        maxyear: yearnow,
        maxmonth: monthnow,
        seedcode: "",
        seedname: "",
        cangkucode: "",
        cangkuname: "",
        Y: '',//球镜
        X: '',//柱镜
        jxcstoreData: [],
        monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        tableData: [],
        tableData2: [],//出入库明细
        tableStoreDetail: [],
        deliverData: [],//待发货
        transfernumData:[],
        text: [],
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        qichu: 0,
        isjingjia: false,
      }
    },
    methods: {
      //汇总
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          var values = [];
          data.map(function (item) {
            if (column.property != 'M' && column.property != 'C'&& column.property != 'erpserial' )
              values.push(Number(item[column.property]));
          });
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      scancode() {
        this.$refs.UniqueCode.show()
      },
      print1() {
          this.tableData = []
          var startDate = new Date(this.title.replace('）', '').substr(6).split('~')[0]);
          var endDate = new Date(this.title.replace('）', '').substr(6).split('~')[1]);

          var data = {
            begindate: startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate(),
            enddate: endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
            seedname: this.seedname,
            seedcode: this.seedcode,
            filltemplate: this.filltemplate,
            initContent: this.initContent,
            initContentLeft: this.initContentLeft,
            initContentRight: this.initContentRight,
            businessType: 'kucunExport',
          }
          exportPdf(data)

      },
      ceshi() {

      },
      lookMachiningCopy(row) {
        this.$refs.machiningeditcopy.initData(row)
        this.$refs.machiningeditcopy.show()
      },

      lookDetailsCopy(row) {
        this.$refs.DataContactEditCopy.initData(row)
        this.$refs.DataContactEditCopy.show()
      },
      lookorder(row) {
        if (row.ordernum) {
          var s = {
            erpserial: row.ordernum
          }
        } else {
          var s = {
            erpserial: row.erpserial
          }
        }

        if (row.ordername == '调拨入库' || row.ordername == '调拨出库') {
          this.$refs.AllocationDetail.initData(s)
          this.$refs.AllocationDetail.show()
        } else if (row.ordername == '采购入库') {
          this.$refs.BuyorderDetail.initData(row, 1)
          this.$refs.BuyorderDetail.show();
        } else if (row.ordername == '坏件库转入') {
          this.$refs.StorageBadOut.show(row.ordernum)
        } else if (row.erpformname == '盘点单') {
          if (this.filltemplate == 80) {
            this.$refs.MakeInventoryFrameEdit.initData(s)
            this.$refs.MakeInventoryFrameEdit.show()
          } else {
            this.$refs.MakeInventoryEdit.initData(s)
            this.$refs.MakeInventoryEdit.show()
          }
        } else if (row.ordername == '报损出库'||row.ordername == '转坏件库') {
          this.$refs.BaoSunDetail.show(row.ordernum)
        } else if (this.filltemplate == "50") {
          this.$refs.machiningedit.initData(s)
          this.$refs.machiningedit.show()
        } else {
          this.$refs.DataContactEdit.initData(s)
          this.$refs.DataContactEdit.show()
        }
      },
      tip() {
        if (this.showtab == 2) {
          return true
        }
        return false
      },
      change1(value) {
        this.Y = value
        this.initStoreDetail()
      },
      change2(value) {
        this.X = value
        this.initStoreDetail()
      },
      //智能库存
      zhinengstock() {
        var obj = {}
        obj.seedcode = this.seedcode
        obj.seedname = this.seedname
        obj.cangkucode = this.cangkucode
        obj.filltemplate = this.filltemplate
        this.$refs.zhinengstock.show(obj)
      },
      exportExcel(val) {

        this.xcolumn = []
        this.ycolumn = []
        var content = this.initContent
        var firstTitle = '球\\柱';
        if (this.filltemplate == 80) {
          firstTitle = '型\\规';
          content.forEach(o => {
            let temp1 = this.xcolumn.filter(item => {
              return item == o.C
            })
            if (temp1.length == 0) {
              this.xcolumn.push(o.C)
            }
            let temp2 = this.ycolumn.filter(item => {
              return item == o.M
            })
            if (temp2.length == 0) {
              this.ycolumn.push(o.M)
            }
          })
          this.xcolumn.sort(this.sequence)
          this.xcolumn.unshift(firstTitle)
          this.xcolumn.push("合计")
          this.ycolumn.sort(this.sequence)

        }

        //下面按照格式拼接
        let data = [] //导出的数据,
        console.log(content)
        this.ycolumn.forEach(y => {
          let heji = 0;
          let temp1 = {}
          temp1[firstTitle] = y;
          this.xcolumn.forEach(x => {
            for (let i in content) {
              if (this.filltemplate == 80 && content[i].C == x && content[i].M == y) {
                temp1[x] = content[i].P
                console.log(temp1[x])
                if (Number(content[i].P))
                  heji += content[i].P
                break;
              }
            }
          })
          temp1['合计'] = heji
          data.push(temp1)
        })
        //导出合计计算
        var hj = {}
        hj[firstTitle] = "合计";

        var zhj = 0;
        this.xcolumn.forEach(x => {
          if (x != firstTitle && x != "合计") {
            hj[x] = 0
            data.forEach(item => {
              if (Number(item[x])) {
                hj[x] = hj[x] + item[x]
              }
            })
            zhj += hj[x]
          }
          //计算总合计
          if (x == "合计") {
            hj[x] = zhj
          }
        })
        data.push(hj)
        let title = "【" + this.seedcode + "】" + this.seedname + "【" + this.minyear + "-" + this.minmonth + "】"

        var biaoti = []
        let header1 = this.xcolumn
        biaoti.push(this.seedcode)
        biaoti.push(this.seedname)
        biaoti.push(formatTimeToStr(new Date()))

        this.$exportExcel(header1, this.xcolumn, data, title, biaoti)
      },
      sequence(a, b) {//从小到大排列
        if (a > b) {
          return 1;
        } else if (a < b) {
          return -1
        } else {
          return 0;
        }
      },
      getPackagesize(Packagesize,col) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        return ps[col]
      }
      ,
      //待发货
      stayDeliver() {
        var item=  {seedcode: this.checkXL?'':this.seedcode,
          categorycode: this.checkXL?this.categorycode:'',
          cangkucode: this.cangkucode};

        stayDelivar(item).then(response => {
          this.deliverData = response.data.obj;
        })

        stayTransfernumMap(item).then(response =>{
          this.transfernumData = response.data.obj;
          for (let i in this.transfernumData) {
            this.transfernumData[i]['ordername'] = '调拨入库'
          }
        })
      },
      initStoreDetail()//过滤出入库明细
      {
        //1、获取期初
        var existSearch = this.Y || this.X;
        var qichu = 0, debit = 0, credit = 0;

        for (let i in this.tableData) {
          var o = this.tableData[i]
          if (!this.checkXL && this.packagesize) {
            if (!(this.packagesize == o.packagesize)) {
              continue;
            }
          }

          if (existSearch && o.packagesize) {
            var packagesize = JSON.parse(o.packagesize)
            if ((this.Y && !packagesize['M'].toUpperCase().includes(this.Y.toUpperCase())) ||
              (this.X && !packagesize['C'].toUpperCase().includes(this.X.toUpperCase()))) {
              continue;
            }
          }

          qichu += o.qichu
        }

        this.tableData2 = []
        for (let i in this.tableStoreDetail) {
          var o = this.tableStoreDetail[i]

          if (o.ordernum == '期初余额' || o.ordernum == '合计') {
            if (o.ordernum == '合计') {
              o.debitnum = debit;
              o.creditnum = credit;
            }
            o.subtractnum = qichu;
            this.tableData2.push(o);
            continue;
          }

          if (!this.checkXL && this.packagesize) {
            if (!(this.packagesize == o.packagesize)) {
              continue;
            }
          }

          if (existSearch && o.packagesize) {
            var packagesize = JSON.parse(o.packagesize)
            var needAdd = false;
            if (packagesize.M) {
              if ((this.Y && !packagesize['M'].toUpperCase().includes(this.Y.toUpperCase())) ||
                (this.X && !packagesize['C'].toUpperCase().includes(this.X.toUpperCase()))) {

              } else {
                needAdd = true;
              }
            } else {
              needAdd = true;
            }

            if (needAdd) {
              debit += o.debitnum | 0;
              credit += o.creditnum | 0;
              qichu += (o.debitnum | 0) - (o.creditnum | 0);
              o.subtractnum = qichu;
              this.tableData2.push(o);
            }
          } else {
            debit += o.debitnum | 0;
            credit += o.creditnum | 0;
            qichu += (o.debitnum | 0) - (o.creditnum | 0);
            o.subtractnum = qichu;
            this.tableData2.push(o);
          }
        }
      },
      //出入库明细
      bindDetail() {
        this.tableStoreDetail=[]
        getStoreFormList({
          seedcode: this.seedcode,//产品分类（单选）
          cangkucode: this.cangkucode,//选择的仓库（单选）
          minyear: this.minyear,
          minmonth: this.minmonth,
          maxyear: this.minyear,
          maxmonth: this.minmonth,
          nostock: 1,
          categorycode:this.categorycode,
          allxili: this.checkXL ? 1 : -1
        }).then(response => {
          if (response.data.code == 0) {
            for(let i in response.data.obj) {
              var row = response.data.obj[i];
              if (row['packagesize']) {
                var pg =JSON.parse(row['packagesize'])
                row.M = pg.M;
                row.C = pg.C;
              } else {
                row.M = ''
                row.C = '';
              }
              this.tableStoreDetail.push(row);
            }
            this.tableStoreDetail.sort(function (a, b) {
              if (a.ordernum == '期初余额') {
                return false;
              } else if (a.ordernum == '合计') {
                return true;
              }
              if (a.M == b.M)
                return a.C.localeCompare(b.C)
              else
                return a.M.localeCompare(b.M)
            })
            this.initStoreDetail();
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        }).catch((error) => {
          console.log(error)
        });
      } ,
      search() {
        this.bindGrid();
      }
      ,
      initData(row, minyear, minmonth, maxyear, maxmonth) {
        this.tableData2 = []
        this.tableData = []
        this.deliverData = []
        this.transfernumData=[]
        this.xcolumn = []
        this.ycolumn = []
        this.minyear = minyear;
        this.minmonth = minmonth;
        this.maxyear = minyear;
        this.maxmonth = minmonth;
        this.filltemplate = 80
        this.cangkucode = row.cangkucode
        this.cangkuname = row.cangkuname
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.categorycode = row.categorycode
        this.packagesize=row.packagesize
        this.dialogFormVisible = true
        this.Y = ''
        this.X = ''
        this.RorL = ''
        this.showtab = 2

        if(this.jxcstoreData.length==0){
          cusandptbyind({}).then(response => {
            this.jxcstoreData = response.data.obj
            this.bindGrid();
          })
        }else{
          this.bindGrid();
        }
      }
      ,
      bindGrid() {
        var existCangku=false;
        for(let i in this.jxcstoreData){
          if(this.jxcstoreData[i].cangkucode==this.cangkucode){
            existCangku=true;
            break;
          }
        }
        if(!existCangku){
          this.cangkucode=this.jxcstoreData[0];
        }
        if(!this.cangkucode)
          return;

        getGoodsListWithStoreDetail({
          seedcode: this.seedcode,//产品分类（单选）
          cangkucode: this.cangkucode,//选择的仓库（单选）
          minyear: this.minyear,
          minmonth: this.minmonth,
          maxyear: this.minyear,
          maxmonth: this.minmonth,
          nostock: 1,
          categorycode: this.categorycode,
          nolimit: "1",
          nobuynum: "1",
          nodeliverying: "1",
          allxili: this.checkXL ? 1 : -1
        }).then(response => {
          this.tableData = response.data.obj
          this.bindDetail();
          //待发货
          this.stayDeliver();
        }).catch((error) => {
          console.log(error)
        });
      }
      ,
      getYearList() {
        var arr = [];
        var yearnow = new Date().getFullYear();
        for (let i = 2020; i <= yearnow; i++) {
          arr.push(i)
        }
        return arr
      }
    },
    watch: {}
    ,
    mounted() {

    }
    ,
    components: {
      TwoDimensionalView,
      glassFrameView,
      CstagreementMachiningEdit,
      CstagreementEdit,
      AllocationDetail,
      BuyorderDetail,
      MakeInventoryEdit,
      MakeInventoryFrameEdit,
      StorageBadOut,
      BaoSunDetail,
      UniqueCode,
      zhinengstock
    }
    ,
  }
</script>

<style scoped>
  .erweitable td {
    border: 1px solid #E0DFDF;
    min-width: 80px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }

</style>



// WEBPACK FOOTER //
// src/components/testorder/warehouse/StorageFrameView.vue